<div class="page-container">
  <div class="number">404</div>
  <div class="text">{{'page-not-found'|translate}}</div>
</div>
